import Dashboard from './container'

export default Dashboard
